import {
  Button, Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField
} from '@material-ui/core';
import {useGoVehisService} from "../../utils/axios";
import React, {useEffect, useState} from "react";
import TableHeader from "./table/TableHeader";
import Typography from "@material-ui/core/Typography";

const AkolSellerOfferDialog = ({isOpen = false, onClose, data = null}) => {

  const goVehisService = useGoVehisService();

  const [traderRows, setTraderRows] = useState([]);
  const [dealerRows, setDealerRows] = useState([]);
  const [note, setNote] = useState("");
  const [isEdit, setIsEdit] = useState(false);
  const [noteText, setNoteText] = useState('');
  const [specialOffer, setSpecialOffer] = useState("");
  const [isSpecialOfferEdit, setIsSpecialOfferEdit] = useState(false);
  const [specialOfferText, setSpecialOfferText] = useState('');
  const [dealerNip, setDealerNip] = useState('');

  const handleSaveNote = async () => {
    try {
      await goVehisService.post(`/admin/akol/dealers/${dealerNip}/note`, noteText,
        {
          headers: {
            "Content-Type": "text/plain; charset=utf-8",
          }
        });
      setNote(noteText);
      setIsEdit(false);
      refresh();
    } catch (error) {
      console.error('Error saving note:', error);
    }
  };

  const handleSaveSpecialOfferText = async () => {
    try {
      await goVehisService.post(`/admin/akol/dealers/${dealerNip}/specialOfferText`, specialOfferText,
        {
          headers: {
            "Content-Type": "text/plain; charset=utf-8",
          }
        });
      setSpecialOffer(specialOfferText);
      setIsSpecialOfferEdit(false);
      refresh();
    } catch (error) {
      console.error('Error saving special offer text:', error);
    }
  };


  function refresh() {
    setIsEdit(false);
    setIsSpecialOfferEdit(false);
    if (isOpen === true) {
      goVehisService.get('/admin/offers/' + data.vehicleId + '/akolSeller')
        .then(res => res.data)
        .then(res => {
          if (res.dealerData != null) {
            setDealerNip(res.dealerData.nip);
            setNote(res.dealerData.note)
            setNoteText(res.dealerData.note)
            setSpecialOffer(res.dealerData.specialOfferText)
            setSpecialOfferText(res.dealerData.specialOfferText)
            setDealerRows(
              [
                { label: 'Nazwa', value: res.dealerData.name },
                { label: 'Miasto', value: res.dealerData.city },
                { label: 'Nip', value: res.dealerData.nip },
                { label: 'E-mail', value: res.dealerData.email },
                { label: 'Telefon', value: res.dealerData.phone },
                { label: 'Status', value: res.dealerData.isActive ? 'Aktywny' : 'Nieaktywny' }
              ]
            );
          }
          if (res.traderData != null) {
            setTraderRows(
              [
                { label: 'Imię i nazwisko', value: res.traderData.fullName },
                { label: 'E-mail', value: res.traderData.email },
                { label: 'Telefon', value: res.traderData.phone },
                { label: 'Telefon 2', value: res.traderData.phone2 }
              ]
            );
          }

        });
    }
  }

  useEffect(() => {
    refresh();
  }, [isOpen]);

  return (
    <Dialog onClose={onClose} aria-labelledby="customized-dialog-title" open={isOpen}>
      <DialogTitle id="customized-dialog-title" onClose={onClose}>
        Dane komisu AKOL
      </DialogTitle>
      <DialogContent dividers  style={{minWidth: '450px'}}>
        {
          dealerRows.length > 0 &&
          <TableContainer component={Paper}>
            <Table aria-label="simple table">
              <TableBody>
                {dealerRows.map((row) => (
                  <TableRow key={row.label}>
                    <TableCell component="th" scope="row">
                      <strong>{row.label}</strong>
                    </TableCell>
                    <TableCell align="right">{row.value}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        }
        <div>
          <Typography variant="h6" style={{marginTop: '20px', marginBottom: '10px'}}>
            Notatka
          </Typography>
          <Typography variant="body1">
            {note}
          </Typography>
          {!isEdit && (
            <Button
              variant="contained"
              size="small"
              onClick={() => setIsEdit(true)}
              style={{ marginTop: '10px' }}
            >
              Dodaj notatkę
            </Button>
          )}
          {isEdit && (
            <div style={{ marginTop: '10px' }}>
              <TextField
                fullWidth
                multiline
                rows={4}
                value={noteText}
                onChange={(e) => setNoteText(e.target.value)}
              />
              <Button
                variant="contained"
                color="primary"
                onClick={handleSaveNote}
                style={{ marginTop: '10px' }}
              >
                Zapisz
              </Button>
            </div>
          )}
        </div>
        <div>
          <Typography variant="h6" style={{marginTop: '20px', marginBottom: '10px'}}>
            Tekst oferty specjalnej
          </Typography>
          <Typography variant="body1">
            {specialOffer}
          </Typography>
          {!isSpecialOfferEdit && (
            <Button
              variant="contained"
              size="small"
              onClick={() => setIsSpecialOfferEdit(true)}
              style={{ marginTop: '10px' }}
            >
              Dodaj tekst oferty specjalnej
            </Button>
          )}
          {isSpecialOfferEdit && (
            <div style={{ marginTop: '10px' }}>
              <TextField
                fullWidth
                multiline
                rows={4}
                value={specialOfferText}
                onChange={(e) => setSpecialOfferText(e.target.value)}
              />
              <Button
                variant="contained"
                color="primary"
                onClick={handleSaveSpecialOfferText}
                style={{ marginTop: '10px' }}
              >
                Zapisz
              </Button>
            </div>
          )}
        </div>

      </DialogContent>
      {
        traderRows.length > 0 &&
        <DialogTitle id="customized-dialog-title" onClose={onClose}>
          Dane handlowca
        </DialogTitle> &&
        <DialogContent dividers>
          <TableContainer component={Paper}>
            <Typography variant="h6" id="tableTitle" component="div">
              Dane handlowca
            </Typography>
            <Table aria-label="simple table">
              <TableBody>
                {traderRows.map((row) => (
                  <TableRow key={row.label}>
                    <TableCell component="th" scope="row">
                      <strong>{row.label}</strong>
                    </TableCell>
                    <TableCell align="right">{row.value}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

        </DialogContent>
      }


      <DialogActions>
        <Button autoFocus onClick={onClose} color="primary">
          Zamknij
        </Button>
      </DialogActions>
    </Dialog>
  )

}

export default AkolSellerOfferDialog;
